import React from 'react'
import _Input from '../Field/Input/Input'

export const Input = ({ displayAs, ...props }) => {
  const { linkType, prefix } = displayAs?.[0] ?? {}
  return (
    <_Input
      {...props}
      type='tel'
      validRegExp={String.raw`^\(\d{3}\) \d{3}-\d{4}$`}
      maskRegExp={String.raw`^(?:\()?(\d{0,3})(?:\))?(?: )?(\d{0,3})(?:-)?(\d{0,4})$`}
      maskReplacement='($1) $2-$3'
      maxLength='14'
      onValueChange={props.onValueChange}
      icon={props.value && linkType ? `phone` : props.icon}
      linkType={linkType}
      prefix={prefix}
    />
  )
}

export const Output = props => {
  let data = props.data || props.value
  const { displayAs } = props
  let linkType
  if (Array.isArray(displayAs)) {
    linkType = displayAs[0]?.linkType ?? ''
  } else if (typeof displayAs === 'string') {
    linkType = displayAs
  } else {
    linkType = displayAs?.linkType ?? ''
  }
  if (linkType.toUpperCase() === 'TEL') {
    return <a href={`tel:${data}`}>{data}</a>
  }
  return <span>{data}</span>
}
